import { render, staticRenderFns } from "./OurSkills.vue?vue&type=template&id=67b3e812&scoped=true&"
import script from "./OurSkills.vue?vue&type=script&lang=js&"
export * from "./OurSkills.vue?vue&type=script&lang=js&"
import style0 from "./OurSkills.vue?vue&type=style&index=0&id=67b3e812&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3e812",
  null
  
)

export default component.exports